import { AccountStatus } from '../../../../shared/types/account/AccountStatus';
import { AccountType } from '../../../../shared/types/account/AccountType';

// One line per status / plan — shown under the dropdowns, on the status tile AND in the Help tab, so the
// three never disagree.
export const STATUS_HINTS: Record<AccountStatus, string> = {
  PAID: 'Active, paying — full access.',
  TRIAL: 'Active trial.',
  OVERDUE: 'Payment overdue — the app still works normally.',
  BLOCKED: 'Payment overdue — the user cannot do anything; collecting runs in the background.',
  DISABLED: 'Disabled — nothing runs.',
};

export const ACCOUNT_TYPE_HINTS: Partial<Record<AccountType, string>> = {
  TRIAL: '20 questions / 2 users',
  STANDARD: '10 questions / 1 user',
  PRO: '30 questions / 2 users',
  ADVANCED: '100 questions / 10 users',
  ENTERPRISE: 'custom questions / custom users',
};
